import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

/*
 * Service printCoupon
 */
angular
  .module('posApp')
  .factory('printCoupon', (legacyPrint, settingsManager: SettingsManager) => {
    // TODO move this logic to the print service in v7/shared
    const printCoupon = (transaction) => {
      if (Array.isArray(transaction?.coupon)) {
        transaction.coupon.forEach((coupon) => {
          let additionalInfo = '';

          if (settingsManager.settings.additionalPrintInfo) {
            switch (coupon.type) {
              case 'C':
                additionalInfo =
                  settingsManager.settings.additionalPrintInfo.cashback;
                break;
              case 'T':
                additionalInfo =
                  settingsManager.settings.additionalPrintInfo.creditReceipt;
                break;
            }
          }

          legacyPrint.printCoupon({
            shop: transaction.shop,
            customer: transaction.customer,
            cashier: transaction.cashier,
            coupon,
            printed: transaction.printed,
            additionalInfo,
          });
        });
        // The next else parts will no longer be necessary after DM-673 is released.
      } else if (typeof transaction?.coupon === 'object') {
        legacyPrint.printCoupon(transaction);
      }
    };

    return printCoupon;
  });
